import axios from 'axios'
import { useState, useEffect } from 'react';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import ToastNotification from '../../../components/ToastNotification';
import { CiEdit } from "react-icons/ci";
import Select from "react-select";
import { MdDeleteForever } from "react-icons/md";
import { useLoading } from '../../../context/LoadingContext';

function HSNCode({adminData}) {

     const [showForm, setShowForm] = useState(false);
   const [chargeMaster, setChargeMaster] = useState([]);
   const [editingCompanyId, setEditingCompanyId] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
  const [chargeOptions, setChargeOptions] = useState([]);
    const { setLoading } = useLoading();
  const[hsnCode,setHsnCode] = useState([]);

const [chargeRows, setChargeRows] = useState([
  {
    id: Date.now(),
    chargeType: ""
  }
]);

     const [form, setForm] = useState({
   code: '',
    description: '',
    type:''
  })

    const [searchTerm, setSearchTerm] = useState('');

  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };

  const handleAddClick = () => {
    setShowForm(true);
  };


  const handleAddChargeRow = () => {
  setChargeRows((prev) => [
    ...prev,
    {
      id: Date.now(),
      chargeType: ""
    }
  ]);
};

const handleDeleteChargeRow = (id) => {
  setChargeRows((prev) =>
    prev.filter((row) => row.id !== id)
  );
};

const handleChargeChange = (id, value) => {
  setChargeRows((prev) =>
    prev.map((row) =>
      row.id === id
        ? { ...row, chargeType: value }
        : row
    )
  );
};

  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


const handleSubmit = async (e) => {
  e.preventDefault();

  const sendData = {
    code: form.code,
    description: form.description,
    gst_charges:  chargeRows
     
  };

  try {
    if (isEditMode) {
      await axios.put(
        `https://api.skyguard.group/api/update-master-hsn/${form.id}`,
        sendData,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      showToast("HSN Updated Successfully!", "success");
    } else {
      await axios.post(
        "https://api.skyguard.group/api/add-master-hsn",
        sendData,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      showToast("HSN Added Successfully!", "success");
    }

    setShowForm(false);
    setIsEditMode(false);

    fetchHsn();

resetForm();

  } catch (err) {
    showToast(
      isEditMode
        ? "Failed To Update HSN!"
        : "Failed To Add HSN!",
      "danger"
    );

    console.error(
      "❌ Error:",
      err.response?.data || err.message
    );
  }
};


    const fetchChargeDetail = async () => {
      setLoading(true)
      try {
        const response = await axios.get('https://api.skyguard.group/api/fetch-master-charge');
        setChargeMaster(response.data);
        const options = response.data.map((item) => ({
          value: item.charge_name,
          label: item.charge_name
        }));
  
        setChargeOptions(options);
  
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false);
      }
    };

    
    const fetchHsn = async () => {

    try {
      const resParty = await axios.get('https://api.skyguard.group/api/fetch-hsn-master');
   setHsnCode(resParty.data)
    } catch (error) {
      console.log(error)
    }
  };

  useEffect(() => {
  fetchChargeDetail();
   fetchHsn();
  }, []);


const handleEdit = (selectedForm) => {

  let parsedCharges = [];

  try {
    parsedCharges = selectedForm.gst_charges
      ? JSON.parse(selectedForm.gst_charges)
      : [];
  } catch (error) {
    console.error("Error parsing gst_charges:", error);
    parsedCharges = [];
  }

  // Set normal form fields
  setForm({
    id: selectedForm.id || "",
    code: selectedForm.code || "",
    description: selectedForm.description || ""
  });

  // Set dynamic GST charge rows
  setChargeRows(
    parsedCharges.map((charge) => ({
      id: charge.id || Date.now() + Math.random(),
      chargeType: charge.chargeType || ""
    }))
  );

  setEditingCompanyId(selectedForm.id);
  setIsEditMode(true);
  setShowForm(true);
};
  
      const filteredData = hsnCode.filter(itm =>
    Object.values(itm).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  )

  const resetForm = () => {
        setForm({
      code: "",
      description: ""
    });

    setChargeRows([]);

  }

  return (
     <>
  
      <div className='main-section'>
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
          <ToastNotification
            show={toast.show}
            message={toast.message}
            bg={toast.bg}
            onClose={() => setToast({ ...toast, show: false })}
          />
          <h3 className='my-3 fw-bold fs-5 golos'>HSN Code</h3>

          <div className="mb-3 d-flex flex-wrap align-items-end justify-content-between">
            <div className="mb-2 w-50 w-md-50 pe-md-2">
              <input
                className="form-control w-100"
                list="datalistOptions"
                placeholder="Search by Name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="mb-2">
              <button className="btn btn-success" onClick={handleAddClick}>
                <AiOutlinePlusCircle size={20} /> Add
              </button>
            </div>
          </div>


          {showForm && (


            <div className='card p-3 mb-3  w-75 mx-auto'>
              <form onSubmit={handleSubmit} >

                      {isEditMode && (
  <div className="mb-3">

    <span className="badge bg-primary px-3 py-2">
     {form.code}
    </span>
  </div>
)}

                <hr />

                <div className='row g-3'>

                  <div className="col-md-6">
                    <label htmlFor='name' className="form-label fw-medium" > HSN Code </label>
                    <input type="text" className="form-control" name="code" placeholder="Enter here..." 
                    value={form.code} onChange={handleInputChange} required />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor='middle' className="form-label fw-medium" >Discription</label>
                    <input type="text" className="form-control" name="description" placeholder="Enter here..."
                      value={form.description}
                      onChange={handleInputChange}

                    />
                  </div>

                 <div className="col-md-6">

  <div className="d-flex justify-content-end mb-2">
    <button
      type="button"
      className="btn btn-primary btn-sm"
      onClick={handleAddChargeRow}
    >
      Add
    </button>
  </div>

  <div className="table-responsive">
    <table className="table table-bordered table-sm mb-0">

      <thead>
        <tr>
          <th style={{ width: "80px" }}>Delete</th>
          <th>Tax / Charge Type</th>
        </tr>
      </thead>

      <tbody>
        {chargeRows.map((row) => (
          <tr key={row.id}>

            <td className="text-center">
              <button
                type="button"
                className="btn btn-link text-danger p-0"
                onClick={() => handleDeleteChargeRow(row.id)}
              >
                <MdDeleteForever size={22} />
              </button>
            </td>

            <td>
              <select
                className="form-select form-select-sm"
                value={row.chargeType}
                onChange={(e) =>
                  handleChargeChange(
                    row.id,
                    e.target.value
                  )
                }
              >
                <option value="">
                  Select Tax / Charge
                </option>

                {chargeOptions.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
            </td>

          </tr>
        ))}
      </tbody>

    </table>
  </div>

</div>


                  <div className='gap-2 d-flex justify-content-center mt-4'>

                    <button type="submit" className='btn btn-success w-10'>
                      {isEditMode ? "Update" : "Save"}
                    </button>
                    <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                      setShowForm(false);
                      setIsEditMode(false);
                      resetForm();
                    }}>
                      Cancel
                    </button>
                  </div>

                </div>
              </form>
            </div>
          )}

          <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
            <table className='table table-bordered table-striped table-hover text-center align-middle'>

              <thead className='table-info'>
                <tr>
                   <th scope='col'>SN</th>
                    <th scope='col'>Action</th>
                  <th scope='col'>HSN Code</th>
                  <th scope='col'>Description</th>
               
                </tr>
              </thead>
              <tbody>
                {filteredData.map((acc, idx) => (
                <tr key={idx} >
                     <td>{filteredData.length - idx }</td>
                    <td>  <button
                    className="btn btn-success"
                   
                    onClick={() => handleEdit(acc)}
                  >
                    <CiEdit size={20} />
                  </button>
                  </td>
                  <td> {acc.code} </td>
                  <td> {acc.description}  </td>
                </tr>
              ))}
              </tbody>
            </table>
          </div>



        
        </div>
      </div>
  </>
  )
}

export default HSNCode



